import React, { useEffect } from "react";
import { connect } from "react-redux";
import { changeOrderStatus } from "../../redux/Actions/OrderActions";
import DeleteModal from "../Modal/DeleteModal";

const PendingOrder = (props) => {
  const { changeOrderStatus, id, isChangingStatus, changeSuccess } = props;

  useEffect(
    () => {
      if (changeSuccess) {
        props.closeModal();
      }
    }, // eslint-disable-next-line
    [changeSuccess]
  );

  const payload = {
    status: "pending",
  };

  const handleChange = () => {
    changeOrderStatus(id, payload);
  };
  return (
    <DeleteModal
      displayModal={props.displayModal}
      closeModal={props.closeModal}
      title={"Change order status to pending?"}
      width={"463px"}
      text={"Pending"}
      onClick={handleChange}
      disabled={isChangingStatus}
      isLoading={isChangingStatus}
      activate={true}
      loadingText={"Pending..."}
      children={
        "Once you change this order status, this order would show as pending. Change to Pending?"
      }
      testId={"pendingOrder"}
    />
  );
};

const mapStateToProps = (state) => ({
  isChangingStatus: state.order.isChangingStatus,
  changeSuccess: state.order.changeSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  changeOrderStatus: (id, payload) => dispatch(changeOrderStatus(id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PendingOrder);
